export default __webpack_public_path__ + "static/media/DareToGo.2efa10e1.png";